/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/464-stumbleupon2': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M13.313 0H2.688A2.696 2.696 0 000 2.688v10.625a2.696 2.696 0 002.688 2.688h10.625a2.696 2.696 0 002.688-2.688V2.688A2.696 2.696 0 0013.313 0zM8 5c-.551 0-1 .449-1 1v4c0 1.654-1.346 3-3 3s-3-1.346-3-3V8h2v2c0 .551.449 1 1 1s1-.449 1-1V6c0-1.654 1.346-3 3-3s3 1.346 3 2.781v.969l-1.281.375L9 6.75v-.969C9 5.448 8.551 5 8 5zm7 5c0 1.654-1.346 3-3 3s-3-1.346-3-3.219V7.843l.719.375L11 7.843v1.938c0 .77.449 1.219 1 1.219s1-.449 1-1V8h2v2z"/>'
  }
})
